// ------ W9 ------
export enum W9BusinessTaxClassifications {
  INDIVIDUAL_SOLE_PROPIETOR = 'SolePropietor',
  C_CORPORATION = 'CCorporation',
  S_CORPORATION = 'SCorporation',
  PARTNERSHIP = 'Partnership',
  TRUST_ESTATE = 'TrustEstate',
  LLC = 'Llc',
  OTHER = 'Other',
}

export enum W9TaxClassifications {
  INDIVIDUAL = 'Individual',
  BUSINESS = 'Business',
}

export enum W9LLCTaxClassifications {
  C = 'C',
  S = 'S',
  P = 'P',
}

export enum W9TinValues {
  SSN = 'SocialSecurityNumber',
  EIN = 'EmployerIdentificationNumber',
}

export interface W9FormData {
  taxClassification: W9TaxClassifications;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  signature: string;
  tin: W9TinValues;
  ssn: string;
  businessTaxClassification: W9BusinessTaxClassifications;
  llcBusinessTaxClassification: W9LLCTaxClassifications;
  otherEntityType: string;
  dba: string;
  ein: string;
  exemptPayeeCode: number;
  exemptFATCACode: string;
}

export type CreateW9TaxFormInput = CreateTaxFormInput<W9FormData>;

interface CreateTaxFormInput<TaxFormData> {
  data: TaxFormData;
  type: TaxFormType;
}

export type TaxFormData = W9FormData;

export enum TaxFormType {
  W9 = 'W9',
}

export interface TaxForm {
  id: string;
  userId: string;
  documentId: string;
  type: TaxFormType;
  data: Partial<TaxFormData>;
  deactivatedAt?: Date;
}

export default TaxForm;
